export function uniqueKey(prefix) {
    var ids = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        ids[_i - 1] = arguments[_i];
    }
    return "".concat(prefix, "-").concat(ids.join('-'));
}
//# sourceMappingURL=common.js.map